export default {
  head () {
    const head = this.$nuxtI18nHead({ addDirAttribute: true, addSeoAttributes: true })
    // A 404/error is not a translated, indexable page. Nuxt i18n can otherwise
    // manufacture a canonical from the unmatched request path.
    const unmatched = this.$route && !this.$route.name
    const error = this.$nuxt && this.$nuxt.nuxt && this.$nuxt.nuxt.err
    if (unmatched || error) {
      head.link = []
      return head
    }
    // i18n preserves navigation queries in alternates; indexing URLs must match
    // the clean canonical URLs, without campaign parameters or fragments.
    head.link = head.link.map(link => {
      const url = new URL(link.href)
      url.search = ''
      url.hash = ''
      // The static /en assets directory redirects its root to /en/.
      if (url.pathname === '/en') url.pathname = '/en/'
      return { ...link, href: url.href }
    })
    head.meta = head.meta.map(meta => ({
      ...meta,
      content: { pl: 'pl_PL', en: 'en_US' }[meta.content] || meta.content
    }))
    return head
  }
}
